"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.FieldValidation = React.createContext(null);
//# sourceMappingURL=context.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-form-fields/core/validator/context.js
// module id = 417
// module chunks = 58